import React from "react";
import "./SchoolPartnership.css";
import icon from "../../assetsS/images/cup.png";
import { FaCheckCircle } from "react-icons/fa";

const Gallery = () => {
  const features = [
    "Biology Champion League helps students master the Biology section of NEET, contributing up to 360 marks through 90 questions.",
    "Regular practice strengthens understanding of biological terminology and prepares students for both direct and indirect questions.",
    "Just 30 minutes of daily practice significantly improves retention, speed, accuracy, and familiarity with NEET-level concepts."
  ];

  return (
    <section
      className="py-5"
      style={{
        background:
          "linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)",
      }}
    >
      <div className="container">
        <div className="row align-items-center g-5">
          
          {/* Content */}
          <div className="col-lg-7">
            <span
              className="badge mb-3 px-3 py-2"
              style={{
                background: "#e8f5e9",
                color: "#2e7d32",
                fontSize: "0.9rem",
              }}
            >
              Biology Champion League
            </span>

            <h2
              className="fw-bold mb-4"
              style={{
                fontSize: "clamp(2rem, 4vw, 3rem)",
                color: "#0f172a",
              }}
            >
              Master Biology for NEET with
              <span style={{ color: "#2e7d32" }}>
                {" "}
                Daily Smart Practice
              </span>
            </h2>

            <p
              className="text-muted mb-4"
              style={{
                lineHeight: "1.8",
                fontSize: "1rem",
              }}
            >
              Biology accounts for a major portion of the NEET examination.
              Our Biology Champion League is designed to help students build
              confidence, improve recall, and master scientific terminology
              through structured daily practice.
            </p>

            <div className="d-flex flex-column gap-3">
              {features.map((item, index) => (
                <div
                  key={index}
                  className="d-flex align-items-start"
                >
                  <FaCheckCircle
                    className="me-3 mt-1"
                    color="#2e7d32"
                    size={20}
                  />

                  <span
                    style={{
                      color: "#475569",
                      lineHeight: "1.8",
                    }}
                  >
                    {item}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="col-lg-5">
            <div
              className="position-relative text-center"
            >
              <div
                className="shadow-lg"
                style={{
                  borderRadius: "24px",
                  background: "#fff",
                  padding: "30px",
                }}
              >
                <img
                  src={icon}
                  alt="Biology Champion League"
                  className="img-fluid"
                  style={{
                    maxHeight: "400px",
                    objectFit: "contain",
                  }}
                />
              </div>

              {/* Floating Badge */}
              <div
                className="position-absolute"
                style={{
                  top: "-15px",
                  right: "-15px",
                  background: "#2e7d32",
                  color: "#fff",
                  padding: "12px 18px",
                  borderRadius: "16px",
                  fontWeight: 600,
                  boxShadow:
                    "0 10px 30px rgba(46,125,50,0.25)",
                }}
              >
                360 Marks Potential
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Gallery;